import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ebebeb;
  overflow: hidden;
`;

export const TypeSelectWrap = styled.div`
  width: 100%;

  > div {
    width: 100%;
  }

  > div > div {
    width: 100%;
  }

  select {
    width: 100%;
    height: 36px;
    padding: 0 34px 0 16px;
    border-radius: 999px;
    border: 1px solid #262626;
    background-color: #fff;
    font-size: 13px;
    font-weight: 600;
    color: #262626;
    cursor: pointer;
  }

  @media (min-width: 769px) {
    width: auto;
    flex-shrink: 0;

    > div,
    > div > div {
      width: auto;
    }

    select {
      width: auto;
      min-width: 148px;
    }
  }
`;

export const LoadingSpin = styled.div`
  width: 100%;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    min-height: 30px;
    min-width: 30px;
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  padding: 16px 16px 12px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.12);

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 20px;
  }
`;

export const HeaderTitle = styled.span`
  font-family: 'Mangueira Bold', 'Mangueira', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #262626;
  flex-shrink: 0;
`;

export const Content = styled.div`
  padding: 0;
`;

export const TableSection = styled.div`
  overflow-x: auto;

  table {
    border: none !important;
    table-layout: fixed;
    width: 100%;
  }

  thead th,
  tbody td {
    vertical-align: middle;
  }

  thead th:nth-child(1),
  tbody td:nth-child(1) {
    width: 28%;
    text-align: left !important;
    padding-left: 16px !important;
    padding-right: 4px !important;
  }

  thead th:nth-child(2),
  tbody td:nth-child(2) {
    width: 42%;
    text-align: center !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  thead th:nth-child(3),
  tbody td:nth-child(3) {
    width: 30%;
    text-align: right !important;
    padding-left: 4px !important;
    padding-right: 16px !important;
  }

  thead th {
    background: #fff !important;
    color: #575757 !important;
    font-family: 'Mangueira Bold', 'Mangueira', sans-serif;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.15;
    border-bottom: 2px solid #e0e0e0 !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    white-space: normal;
  }

  thead th:nth-child(1) > span {
    justify-content: flex-start;
    padding-left: 0;
  }

  thead th:nth-child(2) > span {
    justify-content: center;
    padding-left: 0;
  }

  thead th:nth-child(3) > span {
    justify-content: flex-end;
    padding-left: 0;
    margin-left: auto;
    max-width: 72px;
    text-align: right;
  }

  tbody td {
    font-size: 12px;
    color: #575757;
    border-bottom: none !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  tbody td:first-child,
  tbody td:nth-child(3) {
    font-family: 'Mangueira Bold', 'Mangueira', sans-serif;
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    color: #262626;
  }

  tbody tr:nth-of-type(even) {
    background: #f7f7f7;
  }

  tbody tr:nth-of-type(odd) {
    background: #fff;
  }

  @media (min-width: 769px) {
    overflow-x: visible;

    thead th:nth-child(1),
    tbody td:nth-child(1),
    thead th:nth-child(2),
    tbody td:nth-child(2),
    thead th:nth-child(3),
    tbody td:nth-child(3) {
      width: 33.333%;
      text-align: center !important;
      padding-left: 16px !important;
      padding-right: 16px !important;
    }

    thead th {
      font-size: 13px;
      padding: 12px 16px !important;
      white-space: nowrap;
    }

    thead th:nth-child(1) > span,
    thead th:nth-child(2) > span,
    thead th:nth-child(3) > span {
      justify-content: center;
      max-width: none;
      margin-left: 0;
      padding-left: 8px;
    }

    tbody td {
      font-size: 13px;
      padding: 14px 16px !important;
    }

    tbody td:first-child,
    tbody td:nth-child(3) {
      font-size: 14px;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 8px 14px;
  border-top: 2px solid #e0e0e0;

  nav ul {
    gap: 2px;
    flex-wrap: wrap;
    justify-content: center;
  }

  @media (min-width: 769px) {
    padding: 16px 20px 20px;

    nav ul {
      gap: 8px;
    }
  }
`;

export const StatusBadgeWrap = styled.span`
  display: inline-flex;
  justify-content: center;

  span {
    border-radius: 999px;
    border: 1px solid currentColor;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    padding: 4px 10px;
    white-space: nowrap;
  }

  @media (min-width: 769px) {
    span {
      font-size: 12px;
      padding: 4px 12px;
    }
  }
`;
